import { Injectable, Injector } from '@angular/core';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { LazyLoadEvent } from 'primeng/api';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { ReportCertificate4th } from './../model/report-certificate-4th';
import * as FileSaver from 'file-saver';

@Injectable()
export class ReportCertificate4thService extends BaseReportService<ReportCertificate4th> {

  public uri = '/api/report4thCertificate/';

  constructor(injector: Injector) {
    super(injector);
    //console.log('Instance ReportWayToPayService');
  }

  buildSentence(entity?: ReportCertificate4th, event?: LazyLoadEvent): HttpParams {
    return null;
  }

  exportAll4thCertificate(object: any): Observable<Blob> {
    // let ruta =  this.uri   +  "exportAll4thCertificate"; 
    const ruta = `${this.rutaServidor}${this.uri}exportAll4thCertificate`;
    let nameFile: "reportCertificate4th.pdf";
    this.spinnerService.showAll();
    // return this.http.get<PayStub[]>(`${this.url}/search`, {params})
    return this.httpClient.post(ruta, object, { responseType: 'blob' })
      .pipe(
        map(res => {
          this.spinnerService.hideAll();
          let bean = new Blob([res], { type: 'application/pdf' });
          FileSaver.saveAs(bean, nameFile);
          return bean;
        }),
        catchError((err) => {
          console.log("catchError : " + catchError);
          this.spinnerService.hideAll();
          this.notificationService.serverErrorMessage(err.status + ' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
          return new Observable<Blob>();
        })

      );
  }

  exportAll5thCertificate(object: any): Observable<Blob> {
    // let ruta =  this.uri   +  "exportAll4thCertificate"; 
    const ruta = `${this.rutaServidor}${this.uri}exportAll5thCertificate`;
    let nameFile: "reportCertificate5th.pdf";
    this.spinnerService.showAll();
    // return this.http.get<PayStub[]>(`${this.url}/search`, {params})
    return this.httpClient.post(ruta, object, { responseType: 'blob' })
      .pipe(
        map(res => {
          this.spinnerService.hideAll();
          let bean = new Blob([res], { type: 'application/pdf' });
          FileSaver.saveAs(bean, nameFile);
          return bean;
        }),
        catchError((err) => {
          console.log("catchError : " + catchError);
          this.spinnerService.hideAll();
          this.notificationService.serverErrorMessage(err.status + ' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
          return new Observable<Blob>();
        })

      );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/report-certificate-4th.service.ts